import { Box, InputAdornment } from "@mui/material";
import React, { useEffect, useState } from "react";
import TextFieldStyled from "../detailed-form/components/TextFieldStyled";
import { Input, Form, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useDebounce, useLocalStorage } from "../detailed-form/utils/hooks";
import axios from "axios";
import { GET_API_BASE_URL } from "@/app/utils/functions";

const MobileNumberValidator = ({
  id,
  value,
  onVerified,
  disabled = false,
  autoFocus = true,
  shrinkLabel = false,
  placeholder,
  hideLabel = false,
  size = "medium",
}) => {
  const [number, setNumber] = useState(value);
  const [error, setError] = useState({ hasError: false, message: "" });
  const [validationState, setValidationState] = useState(
    value ? "success" : null
  );
  const { addDebounce } = useDebounce();
  const { sessionId } = useLocalStorage();

  useEffect(() => {
    setNumber(value);
  }, [value]);

  const handleSubmit = (phoneNum) => {
    addDebounce(async () => {
      if (phoneNum.length >= 10) {
        await validateNumber(phoneNum);
      } else {
        if (phoneNum !== "") {
          setError({
            hasError: true,
            message: "Incomplete number",
          });
        }
      }
    });
  };

  const handleChange = (e) => {
    const { value = "" } = e.target;
    const cleaned = value.replace(/\D/g, "");
    const isValidLength = cleaned.length <= 11;
    if (/^[0-9]*$/.test(cleaned) && isValidLength) {
      setNumber(cleaned);
      handleSubmit(cleaned);
      setError({ hasError: false, message: "" });
      setValidationState(null);
    }
  };

  const validateNumber = async (phoneNum) => {
    try {
      setValidationState("loading");
      const resp = sessionId
        ? await dummyResponse(phoneNum)
        : await axios.post(
            `${GET_API_BASE_URL()}/verify-phone`,
            {
              phone: phoneNum,
            },
            { withCredentials: true }
          );
      const validationResultResponse = resp?.data || {};
      const {
        responseObject: {
          Result: {
            ValidationResult = "Invalid",
            NumberType = "Landline",
            CountryCode = "UNKNOWN",
          } = {},
        } = {},
      } = validationResultResponse;
      if (
        ValidationResult !== "Valid" &&
        NumberType !== "Mobile" &&
        CountryCode !== "GB"
      ) {
        onVerified(false);
        setError({
          hasError: true,
          message: "Please enter a valid mobile number",
        });
        setValidationState("error");
      } else {
        onVerified(phoneNum);
        setError({ hasError: false, message: "" });
        setValidationState("success");
      }
    } catch (e) {
      console.log("Unable to verify mobile number", e);
      onVerified(false);
      setError({
        hasError: true,
        message: "Error occurred while verifying mobile number",
      });
      setValidationState("error");
    }
  };

  return (
    <Form.Item
      label={hideLabel ? null : "Mobile Number"}
      validateStatus={error.message ? "error" : ""}
      help={error.message}
      hasFeedback
    >
      <Input
        id={id}
        name="mobileNumber"
        variant="outlined"
        disabled={disabled}
        placeholder={placeholder || "Mobile Number"}
        value={number}
        onChange={handleChange}
        size={"large"}
        // autoFocus={true}
        // type="number"
        inputMode="numeric"
        onKeyDown={(e) =>
          ["ArrowUp", "ArrowDown"].includes(e.key) && e.preventDefault()
        }
        suffix={
          validationState !== "loading" ? (
            error.message ? null : (
              <img
                src="/ssl-secured.png"
                alt="ssl-security"
                style={{ width: 60, borderRadius: "6px" }}
              />
            )
          ) : (
            <Spin indicator={<LoadingOutlined spin />} size="small" />
          )
        }
      />
    </Form.Item>
    // <Box>
    //   <TextFieldStyled
    //     id={id}
    //     fullWidth
    //     variant="outlined"
    //     placeholder={placeholder || "Mobile Number"}
    //     label={hideLabel ? null : "Mobile Number"}
    //     // required
    //     maxRows={1}
    //     multiline={true}
    //     error={error.hasError}
    //     // helperText={error.message}
    //     value={number}
    //     name="mobileNumber"
    //     onChange={handleChange}
    //     type="number"
    //     inputProps={{
    //       inputMode: "numeric",
    //     }}
    //     state={state}
    //     autoFocus={autoFocus}
    //     InputLabelProps={{
    //       shrink: shrinkLabel,
    //     }}
    //     showInputProgress={true}
    //     size={size}
    //     InputProps={{
    //       endAdornment: !state && (
    //         <InputAdornment position="end">
    //           <img
    //             src="/ssl-secured.png"
    //             alt="ssl-security image"
    //             style={{ width: 60, borderRadius: "6px" }}
    //           />
    //         </InputAdornment>
    //       ),
    //     }}
    //   />
    // </Box>
  );
};

export default MobileNumberValidator;

const dummyResponse = async (number) => {
  const resp = {
    success: true,
    message: "Verification Proceeded",
    responseObject: {
      Status: {
        Success: true,
        ErrorMessage: null,
        CreditsRemaining: 14008,
      },
      Result: {
        TelephoneNumber: `44${number}`,
        ValidationResult: "Valid",
        ValidationLevel: "FullNumber",
        NumberType: "Mobile",
        Location: "GBR",
        Provider: "Stour Marine",
        CountryCode: "GB",
        CountryName: "United Kingdom",
      },
    },
    statusCode: 200,
  };

  return { data: resp };
};
